module.exports = __webpack_public_path__ + "static/img/video6.18859e16.png";